import { render } from "./Elemento_ElemEqui.vue?vue&type=template&id=1cb4aba2"
import script from "./Elemento_ElemEqui.vue?vue&type=script&lang=js"
export * from "./Elemento_ElemEqui.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__